﻿<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumb-container">
        @if (instructions) {
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/summary']">
                <i class="fa fa-home"></i>
              </a>
            </li>
            @for (i of instructions; track i; let id = $index) {
              <li class="breadcrumb-item" [ngClass]="i.class">
                @if (i.linkDSL) {
                  <a id="{{'breadcrumb-' + id}}" [routerLink]="i.linkDSL">
                    @if (i.icon) {
                      <i class="fa" [ngClass]="i.icon"></i>
                    }
                    {{translateTitle(i.title)}}
                  </a>
                }
                @if (!i.linkDSL) {
                  <span id="{{'breadcrumb-' + id}}">
                    @if (i.icon) {
                      <i class="fa" [ngClass]="i.icon"></i>
                    }
                    {{translateTitle(i.title)}}
                  </span>
                }
              </li>
            }
          </ol>
        }
        <div class="breadcrumb-portal">
          @for (portal of portals; track portal) {
            <ng-template [cdkPortalOutlet]="portal"></ng-template>
          }
        </div>
      </div>
      <div id="BreadcrumbPortal"></div>
    </div>
  </div>
</div>
